import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import {Link} from 'react-router-dom';

const styles = {
  card: {
    marginTop: 15,
    marginBottom: 15,
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: 280
  },
  media: {
    //height: 40,
    paddingTop: '56.25%', // 16:9
  },
};

function SimpleMediaCard(props) {
  const { classes, enumerate } = props;
  const {heading, title, description, icon, route} = props.cardData;
  return (
      <Card className={classes.card}>
      {enumerate>0?<div className="card-enumeration">{enumerate}</div>:null}
        <CardMedia
          className={classes.media}
          style={{backgroundSize: "cover"}}
          image={icon?icon:"https://s3.ap-south-1.amazonaws.com/illumineschool/homeimg1-op.jpg"}
          title="Illumine Awaken"
        />
        <CardContent>
          <Typography gutterBottom variant="subheading">
            {heading}
          </Typography>
          <Typography gutterBottom variant="title">
            {title}
          </Typography>
          <Typography gutterBottom>
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button size="small" color="primary" component={Link} to={route}>
            View
          </Button>
        </CardActions>
      </Card>
  );
}

SimpleMediaCard.propTypes = {
  classes: PropTypes.object.isRequired,
  cardData: PropTypes.object.isRequired,
  enumerate: PropTypes.number
};

export default withStyles(styles)(SimpleMediaCard);


// WEBPACK FOOTER //
// ./src/components/SimpleMediaCard/index.js